import axios from "axios";
import authHeader from "./AuthHeader";
import { API_URL } from "../config/api";

class CashFlowsService {
  // Get cashFlows chart dataset
  getCashFlowsDataset = async ({ selectedYear = "" }) => {
    const params = new URLSearchParams();
    if (selectedYear) params.append("selectedYear", selectedYear);
    const url = `${API_URL}/dataset/cashFlows?${params.toString()}`;
    return await axios.get(url, { headers: authHeader() });
  };
}

export default new CashFlowsService();
